/**
 * Service local ja session storagen käpistelyä varten.
 * Miksi ei suoraan käpistellä selaimen storageja? Koska tämä sallii myös metadatan
 * tallentamisen ja antaa rajapinnan datan helppoon käsittelyyn metadatan kanssa.
 *
 * Voidaan tulevaisuudessa lisätä esim. listener-toiminnallisuus storagen arvojen
 * muutoksien tarkkailuun.
 */
app.factory("BrowserStorageService",
	["CookieService", function(CookieService) {

		/**
		 * Jokaisella local/session storageen tungettavassa objektissa on metadata-kenttiä.
		 * updated-kenttä pitää kirjaa siitä, koska arvo on asetettu tai päivitetty.
		 * @param data
		 * @returns {{updated: (string|*), data: *}}
		 * @constructor
		 */
		function StorageObject(data) {
			return {
				updated: new Date().toJSON(),
				data: data
			};
		}

		/**
		 * Browser storage, voidaan alustaa eri storagetyypillä, joka noudattaa
		 * localStoragen standardin mukaista rajapintaa.
		 * @param storageContainer
		 * @constructor
		 */
		function BrowserStorage(storageContainer) {

			this.storageContainer = storageContainer;

			this.SetItem = function(key, data) {
				var storageObj = new StorageObject(data);
				this.storageContainer.setItem(key, angular.toJson(storageObj));
			};

			this.GetItem = function(key, withMetaData) {
				var item = this.storageContainer.getItem(key);
				if(item === null) {
					console.warn("Tried to get a non-existing item '" + key + "' from browser storage");
					return null;
				}
				try {
					var storageObj = angular.fromJson(item);
					if(withMetaData) {
						return storageObj;
					}
					else {
						return storageObj.data;
					}

				}
				catch(e) {
					this.RemoveItem(key);
					console.warn("Got malformed item '" + key + "' from browser storage, removing it");
				}

			};

			this.RemoveItem = function(key) {
				this.storageContainer.removeItem(key, true);
			};

			this.HasExpired = function(key, seconds) {
				var item = this.GetItem(key, true);
				if(item === null) {
					return true;
				}
				var itemDate = new Date(item.updated);
				var now = Date.now();
				if(itemDate.getTime() + seconds < now) {
					return true;
				}
				return false;
			};

			this.ClearAllItems = function() {
				this.storageContainer.clear();
			};
		}

		function SessionStorage() {

		}

		/**
		 * LocalStorage is not in use. Use our WindowStorageProvider, which has cookie fail-over.
		 *
		 * To avoid filling up cookie storage we specify which keys we save to cookies.
		 *
		 * @type {{Storage: {}, cookieKeys: [*], init: WindowStorageProvider.init, setItem: WindowStorageProvider.setItem, getItem: WindowStorageProvider.getItem, removeItem: WindowStorageProvider.removeItem, clear: WindowStorageProvider.clear}}
		 */
		this.WindowStorageProvider = {
			Storage: {},
			cookieKeys: ['ApartmentSearchQuery', 'monthlyPayment', 'frontPageAgencySearchInit', 'OnlineOfferSearchQuery'],
			init: function() {
				for (var i in this.cookieKeys) {
					var cookie = CookieService.get('kmStorage' + this.cookieKeys[i]);
					if (cookie) {
						var data = new StorageObject(cookie);
						this.Storage[this.cookieKeys[i]] = data;
					}
				}
			},
			setItem: function (key, data) {
				var storageObj = new StorageObject(data);
				this.Storage[key] = angular.toJson(storageObj);
				if (this.cookieKeys.indexOf(key) > -1) {
					CookieService.set('kmStorage' + key, data);
				}
			},
			getItem: function (key, withMetaData) {
				var item = this.Storage[key] || null;
				if (item === null) {
					console.warn("Tried to get a non-existing item '" + key + "' from WindowStorageProvider");
					return null;
				}
				try {
					var storageObj = angular.fromJson(item);
					if (withMetaData) {
						return storageObj;
					}
					else {
						return storageObj.data;
					}

				}
				catch (e) {
					this.RemoveItem(key);
					console.warn("Got malformed item '" + key + "' from WindowStorageProvider, removing it");
				}
			},
			removeItem: function (key) {
				delete this.Storage[key];
				if (this.cookieKeys.indexOf(key) > -1) {
					CookieService.remove('kmStorage' + key);
				}
			},
			clear: function() {
				this.Storage = {};
				for (var i in this.cookieKeys) {
					CookieService.remove('kmStorage' + this.cookieKeys[i]);
				}
			},
		};
		this.WindowStorageProvider.init();

		this.SessionStorage = new BrowserStorage(window.sessionStorage);
		this.LocalStorage = new BrowserStorage(window.localStorage);
		this.WindowStorage = new BrowserStorage(this.WindowStorageProvider);
		/* If localStorage isn't working use windowStorage as default! */
		try {
			window.localStorage.setItem('localStorageTest', 'localStorageTest');
			window.localStorage.removeItem('localStorageTest');
		} catch (e) {
			this.LocalStorage = this.WindowStorage;
		}
		return this;
	}]
);
